"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgSplit(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M12 4a1 1 0 011 1v1h6a1 1 0 011 1v10a1 1 0 01-1 1h-6v1a1 1 0 01-2 0l-.001-2H5.066C4.477 17 4 16.552 4 16s.477-1 1.066-1H11v-2H5.066C4.477 13 4 12.552 4 12s.477-1 1.066-1H11V9H5.066C4.477 9 4 8.552 4 8s.477-1 1.066-1H11V5a1 1 0 011-1z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Split')(SvgSplit);
//# sourceMappingURL=Split.js.map